import React, { useState } from "react"
import UploadForm from "./UploadForm"
import PublishedDisplay from "./PublishedDisplay"
import ErrorDisplay from "./ErrorDisplay"
import t from "frontend/utils/translations"

import "frontend/styles/icons.css"
import { PRIVACY_MAP } from "./constants"
import {
  createPublishData,
  createUploadInfo,
  logUploadFlowEvent,
  publishSlideshow,
  startFileUpload,
  UserError,
} from "frontend/utils"

const UploadCard = (props) => {
  const { file, onPublish, onUpload, onDelete } = props
  const [hasError, setHasError] = useState(false)
  const [publishedSlideshow, setPublishedSlideshow] = useState({})
  const [embedUrl, setEmbedUrl] = useState("")
  const [slideshowType, setSlideshowType] = useState("")

  const [uploadInfo, setUploadInfo] = useState({})
  const [progress, setProgress] = useState(0)
  const [progressMessage, setProgressMessage] = useState("")

  const updateProgressAndMessage = (updatedProgress, updatedMessage) => {
    setProgressMessage(updatedMessage)
    setProgress(updatedProgress)
  }

  const publishFile = async (data) => {
    const publishedData = await publishSlideshow(data)
    setPublishedSlideshow(publishedData)
    onPublish(file, PRIVACY_MAP[publishedData.detailed_privacy_level])
  }

  const uploadFile = async () => {
    try {
      const dataToUpload = createUploadInfo(file)
      const uploadResponse = await startFileUpload(dataToUpload, file, updateProgressAndMessage)
      setUploadInfo(dataToUpload) // Save data to state
      setSlideshowType(uploadResponse.slideshowType)
      setEmbedUrl(uploadResponse.embed_url)
      onUpload(file)
    } catch (e) {
      logUploadFlowEvent("rejected")
      logUploadFlowEvent("cancelled")

      setHasError(true)

      const errorMessage = e instanceof UserError ? e.message : t("upload.form.error.try_again")
      setProgressMessage(errorMessage)

      console.warn("Upload error:", e)
    }
  }

  const reuploadFile = () => {
    setHasError(false)
    setProgress(0)
  }

  const handleSubmit = async (formValues) => {
    const dataToSubmit = createPublishData(uploadInfo, formValues)
    try {
      await publishFile(dataToSubmit)
    } catch (e) {
      setHasError(true)
      setProgressMessage(t("upload.form.error.try_again"))
      console.warn("Upload error:", e)
    }
  }

  if (hasError) {
    return (
      <ErrorDisplay
        filename={file.filename}
        message={progressMessage}
        onRetry={reuploadFile}
        onDelete={() => onDelete(file)}
      />
    )
  }

  if (file.isPublished) {
    return <PublishedDisplay slideshow={publishedSlideshow} embedUrl={embedUrl} />
  }

  return (
    <UploadForm
      uploadFile={uploadFile}
      onDelete={onDelete}
      onSubmit={handleSubmit}
      file={file}
      embedUrl={embedUrl}
      slideshowType={slideshowType}
      progress={progress}
      progressMessage={progressMessage}
    />
  )
}

UploadCard.defaultProps = {
  onUpload: () => {},
  onPublish: () => {},
  onDelete: () => {},
}

export default UploadCard
